// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__D6hF1","option":"styles_option__48s-V","selected":"styles_selected__zZa10"};